import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  HttpMethod_GET_getInstance1esunrp6hgoe5 as HttpMethod_GET_getInstance,
  get_fetchInterceptors6jomi3psp8vc as get_fetchInterceptors,
} from './fetch.mjs';
import {
  httpHeaders3s629sxokj9k6 as httpHeaders,
  platformFetch2wfqppk9q49jw as platformFetch,
  platformWebSocketv2zo0o1wd8e9 as platformWebSocket,
} from './fetch.js.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { toList3jhuyej2anx2q as toList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { asReversed308kw52j6ls1u as asReversed } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ReversedViews.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.platform_1 = PlatformHttpFetcher_instance;
        this.default_1 = new (GlobalInterceptorHttpFetcher())(this.platform_1);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function fetch$default(url, method, headers, body, onUploadProgress, onDownloadProgress, $completion, $super) {
  method = method === VOID ? HttpMethod_GET_getInstance() : method;
  headers = headers === VOID ? httpHeaders() : headers;
  body = body === VOID ? null : body;
  onUploadProgress = onUploadProgress === VOID ? null : onUploadProgress;
  onDownloadProgress = onDownloadProgress === VOID ? null : onDownloadProgress;
  return $super === VOID ? this.fetch_mearou_k$(url, method, headers, body, onUploadProgress, onDownloadProgress, $completion) : $super.fetch_mearou_k$.call(this, url, method, headers, body, onUploadProgress, onDownloadProgress, $completion);
}
var HttpFetcherClass;
function HttpFetcher() {
  if (HttpFetcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'HttpFetcher', VOID, VOID, VOID, [6]);
    HttpFetcherClass = $;
  }
  return HttpFetcherClass;
}
var PlatformHttpFetcherClass;
function PlatformHttpFetcher() {
  if (PlatformHttpFetcherClass === VOID) {
    class $ {
      *fetch_mearou_k$(url, method, headers, body, onUploadProgress, onDownloadProgress, $completion) {
        return yield* platformFetch(url, method, headers, body, onUploadProgress, onDownloadProgress, $completion);
      }
      webSocket_6fl9o3_k$(url) {
        return platformWebSocket(url);
      }
    }
    protoOf($).fetch$default_g82v7y_k$ = fetch$default;
    initMetadataForObject($, 'PlatformHttpFetcher', VOID, VOID, [HttpFetcher()], [6]);
    PlatformHttpFetcherClass = $;
  }
  return PlatformHttpFetcherClass;
}
var PlatformHttpFetcher_instance;
function PlatformHttpFetcher_getInstance() {
  return PlatformHttpFetcher_instance;
}
function GlobalInterceptorHttpFetcher$fetch$slambda(this$0, $onUploadProgress, $onDownloadProgress) {
  return constructCallableReference((u, m, h, b, $completion) => orPromise($completion, function *($completion) {
    return yield* this$0.wrapped_1.fetch_mearou_k$(u, m, h, b, $onUploadProgress, $onDownloadProgress, $completion);
  }), 4);
}
var GlobalInterceptorHttpFetcherClass;
function GlobalInterceptorHttpFetcher() {
  if (GlobalInterceptorHttpFetcherClass === VOID) {
    class $ {
      constructor(wrapped) {
        this.wrapped_1 = wrapped;
      }
      *fetch_mearou_k$(url, method, headers, body, onUploadProgress, onDownloadProgress, $completion) {
        var tmp = toList(get_fetchInterceptors());
        return yield* applyInterceptors(tmp, url, method, headers, body, GlobalInterceptorHttpFetcher$fetch$slambda(this, onUploadProgress, onDownloadProgress), $completion);
      }
      webSocket_6fl9o3_k$(url) {
        return this.wrapped_1.webSocket_6fl9o3_k$(url);
      }
    }
    protoOf($).fetch$default_g82v7y_k$ = fetch$default;
    initMetadataForClass($, 'GlobalInterceptorHttpFetcher', VOID, VOID, [HttpFetcher()], [6]);
    GlobalInterceptorHttpFetcherClass = $;
  }
  return GlobalInterceptorHttpFetcherClass;
}
function *applyInterceptors(interceptors, url, method, headers, body, terminal, $completion) {
  var proceed = terminal;
  var _iterator__ex2g4s = asReversed(interceptors).iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var interceptor = _iterator__ex2g4s.next_20eer_k$();
    var next = proceed;
    proceed = applyInterceptors$slambda(interceptor, next);
  }
  return yield* $(proceed(url, method, headers, body, $completion), $completion);
}
function applyInterceptors$slambda($interceptor, $next) {
  return constructCallableReference((u, m, h, b, $completion) => orPromise($completion, function *($completion) {
    return yield* $($interceptor(u, m, h, b, $next, $completion), $completion);
  }), 4);
}
//region block: init
PlatformHttpFetcher_instance = new (PlatformHttpFetcher())();
//endregion
//region block: exports
export {
  Companion_getInstance as Companion_getInstance1gp5vi6mchd0u,
};
//endregion

//# sourceMappingURL=HttpFetcher.mjs.map
